import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GROUP_COUNT = 3;
const BOOKS_PER_GROUP = 5;

export default function TextbookSystem() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('curriculum.textbooks.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('curriculum.textbooks.title')}
          </h2>
          {String(t('curriculum.textbooks.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('curriculum.textbooks.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-300 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        <div className="space-y-14 max-w-[800px] mx-auto">
          {Array.from({ length: GROUP_COUNT }, (_, gIdx) => (
            <div key={gIdx}>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-5 pb-3 border-b border-white/10">
                <h3 className="font-heading text-[16px] text-foreground-50 tracking-[0.05em]">
                  {t(`curriculum.textbooks.groups.${gIdx}.title`)}
                </h3>
                <span className="text-[12px] text-accent-500/80 tracking-[0.06em] border border-accent-500/20 px-2.5 py-0.5 whitespace-nowrap self-start sm:self-auto">
                  {t(`curriculum.textbooks.groups.${gIdx}.note`)}
                </span>
              </div>

              <div className="space-y-4">
                {Array.from({ length: BOOKS_PER_GROUP }, (_, idx) => (
                  <div
                    key={idx}
                    className="flex flex-col sm:flex-row gap-5 p-5 bg-foreground-950/40 border border-white/8 group hover:border-accent-500/20 transition-all duration-300"
                  >
                    {/* Book code */}
                    <div className="flex-shrink-0 flex items-start">
                      <div className="w-10 h-10 flex items-center justify-center bg-accent-500/15 text-accent-400 font-heading text-sm tracking-[0.06em]">
                        {t(`curriculum.textbooks.groups.${gIdx}.books.${idx}.code`)}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
                        <h4 className="font-heading text-[16px] text-foreground-50 tracking-[0.05em] group-hover:text-accent-400 transition-colors">
                          {t(`curriculum.textbooks.groups.${gIdx}.books.${idx}.title`)}
                        </h4>
                        <span className="text-[12px] text-accent-500/80 tracking-[0.06em] border border-accent-500/20 px-2.5 py-0.5 whitespace-nowrap self-start sm:self-auto">
                          {t(`curriculum.textbooks.groups.${gIdx}.books.${idx}.courses`)}
                        </span>
                      </div>
                      <p className="text-[14px] text-foreground-300 tracking-[0.03em] leading-relaxed">
                        {t(`curriculum.textbooks.groups.${gIdx}.books.${idx}.description`)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Detail link */}
        <div className="text-center mt-10">
          <Link
            to="/materials"
            className="inline-flex items-center gap-2 text-accent-400 hover:text-accent-300 text-[15px] tracking-[0.08em] transition-colors cursor-pointer"
          >
            {t('curriculum.textbooks.detailLink')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
